var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { class: `badge badge-${_vm.statuses[_vm.status]?.status}` },
    [_vm._v(_vm._s(_vm.statuses[_vm.status]?.title))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }